var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('a',{staticClass:"fa fa-lg ml-1 fa-file-excel-o text-primary",attrs:{"title":"Commercial Invoice en Excel","target":"_blank","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.downloadWithAxios(_vm.row.id, _vm.row.boarding_number)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }